import { match, P } from 'ts-pattern';
import { TimePointType } from '../../../api/timeranges/types';
import { Languages } from '../../../constants';
import {
  formatFinQuarter,
  formatFinYear,
  formatMonth,
  formatYear,
} from '../../../utils-date';
import { Granularity, TimeSliderGranularity } from './types';

export const dateFormatter = (
  date: TimePointType,
  granularity: TimeSliderGranularity,
  locale: Languages
): string => {
  return match({ granularity, date })
    .with(
      { granularity: { value: Granularity.MONTH }, date: P.instanceOf(Date) },
      (v) => formatMonth(v.date, locale)
    )
    .with({ granularity: { value: Granularity.YEAR }, date: P.number }, (v) =>
      formatYear(v.date, locale)
    )
    .with(
      {
        granularity: { value: Granularity.FINQUARTER },
        date: { year: P.number, quarterOfYear: P.number },
      },
      (v) => formatFinQuarter(v.date, locale)
    )
    .with(
      { granularity: { value: Granularity.FINYEAR }, date: P.number },
      (v) => formatFinYear(v.date, locale)
    )
    .otherwise(() => {
      throw new Error(
        `Unsupported granularity and date data type ${granularity.value}, ${typeof date}`
      );
    });
};

export const displayDateRange = (
  start: TimePointType,
  end: TimePointType,
  granularity: TimeSliderGranularity,
  locale: Languages
) => {
  return `${dateFormatter(start, granularity, locale)} - ${dateFormatter(end, granularity, locale)}`;
};

export const displayDate = (
  date: TimePointType,
  granularity: TimeSliderGranularity,
  locale: Languages
) => {
  return `${dateFormatter(date, granularity, locale)}`;
};
